/* @flow */

import React from 'react';
import { Message, Divider, Card, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import OctoResourceImage from 'shared/components/OctoResourceImage';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => (
  <div>
    <Card centered>
      <Card.Content header={content.header.title} />
      <OctoResourceImage
        strategy={content.header.resourceStrategy}
        resource={content.header.image}
      />
      {content.header.page &&
        content.header.page.id && (
          <Card.Content extra>
            <Link
              to={`/view/${content.header.page.id}`}
              className="ui basic labeled fluid icon button"
            >
              <Icon name="pointing right" />
              Naviguer
            </Link>
          </Card.Content>
        )}
    </Card>
    <Divider />
    <Message
      icon="newspaper"
      header="Actualités"
      content={`Les actualités sont gérées via le module dédié de gestion d'actualités`}
    />
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/home/View.js